export default "__VITE_ASSET__8eabc9b0__"